<!-- Page Header -->
<section class="cuspage-hero">
    <div class="cuspage-hero__bg"></div>
    <div class="container">
        <div class="cuspage-hero__content">
            <h1 class="cuspage-hero__title">{{ 'annuaire_titre' | translate }}</h1>
            <p class="cuspage-hero__sub">{{ 'annuaire_sous_titre' | translate }}</p>
            <form class="cuspage-search" (ngSubmit)="search()">
                <div class="cuspage-search__inner">
                    <i class="icofont-search-1 cuspage-search__icon"></i>
                    <input class="cuspage-search__input"
                           type="text"
                           [placeholder]="'annuaire_recherche_ph' | translate"
                           (keyup.enter)="search()"
                           [(ngModel)]="query"
                           name="query"
                           autocomplete="off" />
                    <button class="cuspage-search__btn" type="submit">
                        {{ 'annuaire_rechercher' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>

<!-- Annuaire Section -->
<section class="arp-annuaire-section">
  <div class="container">

    <!-- Stats row -->
    <div *ngIf="stats" class="arp-stats-row arp-anim-in">
      <div class="arp-stat-card">
        <span class="arp-stat-num">{{ stats.total_influencers ?? 0 }}</span>
        <span class="arp-stat-label">{{ 'annuaire_influenceurs' | translate }}</span>
      </div>
      <div class="arp-stat-card">
        <span class="arp-stat-num">{{ stats.total_agencies ?? 0 }}</span>
        <span class="arp-stat-label">{{ 'annuaire_agences' | translate }}</span>
      </div>
      <div class="arp-stat-card">
        <span class="arp-stat-num">{{ stats.total_calligraphers ?? 0 }}</span>
        <span class="arp-stat-label">{{ 'annuaire_tab_calligraphes' | translate }}</span>
      </div>
      <!-- Licences suspendues : un clic applique le filtre correspondant -->
      <button type="button" class="arp-stat-card arp-stat-card--suspended"
              [class.active]="onlySuspended"
              (click)="toggleSuspended()"
              [attr.aria-pressed]="onlySuspended">
        <span class="arp-stat-num">{{ stats.total_suspended_licenses ?? 0 }}</span>
        <span class="arp-stat-label">{{ 'annuaire_licences_suspendues' | translate }}</span>
      </button>
    </div>

    <!-- Tabs -->
    <div class="arp-tabs arp-anim-in" [style.animation-delay.ms]="60">
      <!-- Influenceurs -->
      <button class="arp-tab" [class.active]="activeTab === 'influencers'" (click)="setTab('influencers')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke-linecap="round"/>
        </svg>
        {{ 'annuaire_influenceurs' | translate }}
        <span class="arp-tab-count">{{ activeTab === 'influencers' ? filteredInfluencers.length : influencers.length }}</span>
      </button>
      <!-- Agences -->
      <button class="arp-tab" [class.active]="activeTab === 'agencies'" (click)="setTab('agencies')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke-linecap="round"/>
          <polyline points="9 22 9 12 15 12 15 22" stroke-linecap="round"/>
        </svg>
        {{ 'annuaire_tab_agences' | translate }}
        <span class="arp-tab-count">{{ activeTab === 'agencies' ? filteredAgencies.length : agencies.length }}</span>
      </button>

      <button class="arp-tab" [class.active]="activeTab === 'calligraphers'" (click)="setTab('calligraphers')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M12 19l7-7 3 3-7 7-3-3z" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="6" cy="6" r="1.5"/>
        </svg>
        {{ 'annuaire_tab_calligraphes' | translate }}
        <span class="arp-tab-count">{{ activeTab === 'calligraphers' ? filteredCalligraphers.length : calligraphers.length }}</span>
      </button>
    </div>

    <!-- ── Filtre « licence suspendue », valable pour les trois onglets ── -->
    <div class="arp-susp-filter arp-anim-in" *ngIf="!loading" [style.animation-delay.ms]="90">
      <button type="button" class="arp-susp-toggle"
              [class.active]="onlySuspended"
              (click)="toggleSuspended()"
              [attr.aria-pressed]="onlySuspended">
        <span class="arp-susp-toggle__dot" aria-hidden="true"></span>
        {{ 'annuaire_filtre_suspendues' | translate }}
        <span class="arp-susp-toggle__count">{{ suspendedInTab }}</span>
      </button>
      <span class="arp-susp-hint" *ngIf="onlySuspended">
        {{ 'annuaire_filtre_suspendues_actif' | translate }}
      </span>
    </div>

    <!-- ── Filtre par secteur (influenceurs / agences) ─────────────────── -->
    <div class="arp-sector-filter arp-anim-in"
         *ngIf="!loading && availableSectors.length > 0"
         [style.animation-delay.ms]="120">
      <div class="arp-sector-filter__row">
        <span class="arp-sector-filter__label">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <path d="M3 6h18M6 12h12M10 18h4" stroke-linecap="round"/>
          </svg>
          {{ 'annuaire_filtre_secteur' | translate }}
        </span>

        <!-- Select compact (mobile-friendly) -->
        <select class="arp-sector-filter__select" [(ngModel)]="selectedSector" name="sector" (ngModelChange)="currentPage = 1">
          <option value="">{{ 'annuaire_tous_secteurs' | translate }}</option>
          <option *ngFor="let s of availableSectors" [value]="s">{{ s }}</option>
        </select>

        <button *ngIf="selectedSector"
                type="button"
                class="arp-sector-filter__clear"
                (click)="clearSector()"
                [title]="'annuaire_effacer' | translate">
          ✕
        </button>
      </div>

      <!-- Chips (desktop) -->
      <div class="arp-sector-chips">
        <button type="button"
                class="arp-sector-chip"
                [class.active]="!selectedSector"
                (click)="clearSector()">
          {{ 'annuaire_tous_secteurs' | translate }}
        </button>
        <button *ngFor="let s of availableSectors"
                type="button"
                class="arp-sector-chip"
                [class.active]="selectedSector === s"
                (click)="selectSector(s)">
          {{ s }}
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="arp-loading-state">
      <div class="arp-loader"></div>
      <p>{{ 'annuaire_chargement' | translate }}</p>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="arp-alert-error text-center">{{ error }}</div>

    <!-- ── Influenceurs Tab ── -->
    <div *ngIf="!loading && activeTab === 'influencers'">
      <div *ngIf="filteredInfluencers.length === 0" class="arp-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
        </svg>
        <p>{{ 'annuaire_aucun_resultat' | translate }}</p>
      </div>
      <!-- Cartes influenceurs : la photo porte la carte -->
      <div class="arp-inf-grid" *ngIf="filteredInfluencers.length > 0">
        <article *ngFor="let inf of pagedInfluencers; let i = index"
                 class="arp-inf-card arp-anim-in"
                 [class.is-private]="!inf.is_public"
                 [class.is-clickable]="inf.is_public"
                 [style.animation-delay.ms]="i * 60"
                 (click)="openInfluencer(inf)">

          <div class="arp-inf-card__media">
            <!-- Sans photo, ou si elle ne se charge pas : image par défaut de l'annuaire -->
            <img [src]="inf.photo_url || noPhoto" [alt]="inf.display_name" loading="lazy"
                 [class.is-placeholder]="!inf.photo_url" (error)="onImgError($event)">
            <span class="arp-inf-card__scrim"></span>

            <span *ngIf="inf.niche" class="arp-inf-card__niche" dir="auto">{{ inf.niche }}</span>

            <span *ngIf="!inf.is_public" class="arp-inf-card__lock">
              <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1a3 3 0 0 0-3 3v1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-3-3zm0 2a1 1 0 0 1 1 1v1H7V4a1 1 0 0 1 1-1z" fill="currentColor"/></svg>
              {{ 'annuaire_profil_prive' | translate }}
            </span>

            <div class="arp-inf-card__ident">
              <h5 class="arp-inf-card__name" dir="auto">
                <span>{{ inf.display_name }}</span>
                <span class="arp-susp-badge" *ngIf="isSuspended(inf)">{{ 'annuaire_badge_suspendue' | translate }}</span>
                <svg *ngIf="inf.is_verified" class="arp-inf-card__check"
                     viewBox="0 0 24 24" fill="currentColor"
                     [attr.aria-label]="'annuaire_verifie' | translate">
                  <path d="M12 2l2.4 1.8 3-.2.9 2.9 2.5 1.6-1.1 2.8 1.1 2.8-2.5 1.6-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9L3.2 15.9 4.3 13.1 3.2 10.3l2.5-1.6.9-2.9 3 .2L12 2z"/>
                  <path d="M10.6 14.6L8.2 12.2l1.1-1.1 1.3 1.3 3.4-3.4 1.1 1.1-4.5 4.5z" fill="#0f2723"/>
                </svg>
              </h5>
              <span *ngIf="inf.city" class="arp-inf-card__city" dir="auto">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke-linecap="round"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                {{ inf.city }}
              </span>
            </div>
          </div>

          <div class="arp-inf-card__body">
            <p class="arp-inf-card__bio" *ngIf="inf.bio && inf.is_public" dir="auto">{{ inf.bio }}</p>
            <p class="arp-inf-card__bio is-muted" *ngIf="!inf.is_public" dir="auto">{{ 'annuaire_prive_msg' | translate }}</p>

            <!-- Stats masquées tant que la donnée n'est pas renseignée -->
            <div class="arp-inf-card__stats"
                 *ngIf="inf.is_public && (inf.total_followers || inf.social_accounts?.length)">
              <div class="arp-inf-stat" *ngIf="inf.total_followers">
                <strong>{{ formatFollowers(inf.total_followers) }}</strong>
                <span>{{ 'annuaire_abonnes' | translate }}</span>
              </div>
              <div class="arp-inf-stat" *ngIf="inf.social_accounts?.length">
                <strong>{{ inf.social_accounts.length }}</strong>
                <span>{{ 'annuaire_plateformes' | translate }}</span>
              </div>
            </div>

            <div class="arp-inf-card__foot" *ngIf="inf.is_public">
              <div class="arp-inf-card__socials" *ngIf="inf.social_accounts?.length">
                <span *ngFor="let s of inf.social_accounts.slice(0,3)" class="arp-soc-ic" [title]="s.platform">
                  {{ platformIcon(s.platform) }}
                </span>
              </div>
              <span class="arp-inf-card__cta">{{ 'annuaire_voir_fiche' | translate }} <em>+</em></span>
            </div>
          </div>
        </article>
      </div>
    </div>

    <!-- ── Agences Tab ── -->
    <div *ngIf="!loading && activeTab === 'agencies'">
      <div *ngIf="filteredAgencies.length === 0" class="arp-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
        </svg>
        <p>{{ 'annuaire_aucun_resultat' | translate }}</p>
      </div>
      <!-- Cartes agences : le nom porte la carte -->
      <div class="arp-ag-grid" *ngIf="filteredAgencies.length > 0">
        <article *ngFor="let agency of pagedAgencies; let i = index"
                 class="arp-ag-card arp-anim-in"
                 [class.is-private]="!agency.is_public"
                 [class.is-clickable]="agency.is_public"
                 [style.animation-delay.ms]="i * 60"
                 (click)="openAgency(agency)">

          <span class="arp-ag-card__rail" aria-hidden="true"></span>

          <div class="arp-ag-card__top">
            <span class="arp-ag-card__eyebrow">{{ 'annuaire_agence_label' | translate }}</span>
            <div class="arp-ag-card__mark">
              <img [src]="agency.logo_url || noPhoto" [alt]="agency.agency_name" loading="lazy"
                   [class.is-placeholder]="!agency.logo_url" (error)="onImgError($event)">
            </div>
          </div>

          <h5 class="arp-ag-card__name" dir="auto">{{ agency.agency_name }}</h5>
          <span class="arp-susp-badge" *ngIf="isSuspended(agency)">{{ 'annuaire_badge_suspendue' | translate }}</span>
          <span class="arp-ag-card__rule" aria-hidden="true"></span>

          <div class="arp-ag-card__meta">
            <span *ngIf="agency.city" class="arp-ag-chip" dir="auto">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke-linecap="round"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              {{ agency.city }}
            </span>
            <span *ngIf="agency.is_verified" class="arp-ag-chip is-verified">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ 'annuaire_agree_arp' | translate }}
            </span>
            <span *ngIf="!agency.is_public" class="arp-ag-chip is-private">
              <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1a3 3 0 0 0-3 3v1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-3-3zm0 2a1 1 0 0 1 1 1v1H7V4a1 1 0 0 1 1-1z" fill="currentColor"/></svg>
              {{ 'annuaire_profil_prive' | translate }}
            </span>
          </div>

          <p class="arp-ag-card__bio" *ngIf="agency.bio && agency.is_public" dir="auto">{{ agency.bio }}</p>
          <p class="arp-ag-card__bio is-muted" *ngIf="!agency.is_public" dir="auto">{{ 'annuaire_prive_msg' | translate }}</p>

          <div class="arp-ag-card__foot" *ngIf="agency.is_public">
            <span class="arp-ag-card__services" *ngIf="agency.services" dir="auto">
              <em>{{ 'annuaire_services' | translate }}</em>{{ agency.services }}
            </span>
            <span class="arp-ag-card__cta">{{ 'annuaire_voir_fiche' | translate }} →</span>
          </div>
        </article>
      </div>
    </div>


    <!-- ── Calligraphes ─────────────────────────────────────────────── -->
    <div *ngIf="!loading && activeTab === 'calligraphers'">
      <div *ngIf="filteredCalligraphers.length === 0" class="arp-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
        </svg>
        <p>{{ 'annuaire_aucun_resultat' | translate }}</p>
      </div>

      <div class="arp-ag-grid" *ngIf="filteredCalligraphers.length > 0">
        <article *ngFor="let calli of pagedCalligraphers; let i = index"
                 class="arp-ag-card arp-anim-in"
                 [class.is-private]="!calli.is_public"
                 [class.is-clickable]="calli.is_public"
                 [style.animation-delay.ms]="i * 60"
                 (click)="openCalligrapher(calli)">

          <span class="arp-ag-card__rail" aria-hidden="true"></span>

          <div class="arp-ag-card__head">
            <div class="arp-agency-logo">
              <img [src]="calli.photo_url || noPhoto" [alt]="calli.display_name" loading="lazy"
                   [class.is-placeholder]="!calli.photo_url" (error)="onImgError($event)">
            </div>

            <div class="arp-ag-card__id">
              <h3 class="arp-ag-card__name" dir="auto">{{ calli.display_name }}</h3>
              <span class="arp-susp-badge" *ngIf="isSuspended(calli)">{{ 'annuaire_badge_suspendue' | translate }}</span>
              <span class="arp-ag-card__city" *ngIf="calli.city" dir="auto">{{ calli.city }}</span>
            </div>

            <span class="arp-badge-verified" *ngIf="calli.is_verified" [title]="'annuaire_verifie' | translate"></span>
          </div>

          <p class="arp-ag-card__bio" *ngIf="calli.bio" dir="auto">{{ calli.bio }}</p>

          <div class="arp-ag-card__foot" *ngIf="calli.is_public">
            <span class="arp-ag-card__services" *ngIf="calli.specialty" dir="auto">
              <em>{{ 'annuaire_specialite' | translate }}</em>{{ calli.specialty }}
            </span>
            <span class="arp-ag-card__cta">{{ 'annuaire_voir_fiche' | translate }} →</span>
          </div>
        </article>
      </div>
    </div>


    <!-- ── Pagination (commune aux 2 onglets : les getters suivent activeTab) ── -->
    <nav class="arp-pagination" *ngIf="!loading && totalPages > 1" [attr.aria-label]="'annuaire_pagination' | translate">
      <button type="button"
              class="arp-page-btn arp-page-btn--nav"
              [disabled]="currentPage === 1"
              (click)="prevPage()"
              [attr.aria-label]="'annuaire_page_prev' | translate">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="arp-page-btn__txt">{{ 'annuaire_page_prev' | translate }}</span>
      </button>

      <ul class="arp-page-list">
        <li *ngFor="let p of pageNumbers">
          <span *ngIf="p === '…'" class="arp-page-ellipsis">…</span>
          <button *ngIf="p !== '…'"
                  type="button"
                  class="arp-page-btn"
                  [class.active]="p === currentPage"
                  [attr.aria-current]="p === currentPage ? 'page' : null"
                  (click)="goToPage(p)">
            {{ p }}
          </button>
        </li>
      </ul>

      <button type="button"
              class="arp-page-btn arp-page-btn--nav"
              [disabled]="currentPage === totalPages"
              (click)="nextPage()"
              [attr.aria-label]="'annuaire_page_next' | translate">
        <span class="arp-page-btn__txt">{{ 'annuaire_page_next' | translate }}</span>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18l6-6-6-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </nav>

    <p class="arp-page-info" *ngIf="!loading && totalItems > 0" dir="auto">
      {{ 'annuaire_page_info' | translate:{ start: rangeStart, end: rangeEnd, total: totalItems } }}
    </p>

  </div>
</section>